import { useContext } from 'react'
import { AuthContext } from './AuthProvider'

/**
 * Throws outside a provider rather than defaulting.
 *
 * A default of `{ status: 'signedOut' }` would turn a mis-nested component into
 * a sign-in screen — the wiring bug rendering as a plausible product, which is
 * the hardest kind to notice.
 */
export function useAuth() {
  const value = useContext(AuthContext)
  if (value === null) throw new Error('useAuth must be used inside an <AuthProvider>')
  return value
}
